import React from 'react';
import styled from 'styled-components';
import { XCircle } from 'react-feather';
import PropTypes from 'prop-types';
import { media } from 'theme';
import Link from 'app/components/misc/Link';

const Section = styled.div`
  background-color: #ffffff;
  width: 100%;
  padding: 32px 22px 0;
  margin-bottom: 10px;
  border: 1px solid transparent;
`;

const InputContainer = styled.div`
  position: relative;
  align-items: center;
  width: 100%;
`;

const Input = styled.input`
  border: none;
  border-bottom: 1px solid ${props => props.theme.colors.neutral4};
  font-size: 28px;
  font-weight: bold;
  font-family: Open Sans;
  width: 100%;
  padding: 12px 8px;
  &:focus {
    outline: 1px solid ${props => props.theme.colors.neutral2};
  }
  ${media.smallAndDown`
    font-size: 24px;
  `}

  ::placeholder {
    color: #9aa1b3;
  }
`;

const ClearButton = styled.button`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  margin-right: 6px;

  svg {
    fill: ${props => props.theme.colors.neutral5};
    stroke: #ffffff;
  }
`;

const Info = styled.div`
  font-size: 12px;
  padding-top: 18px;
`;

const SearchQnaSection = styled.div`
  background-color: rgba(87, 207, 141, 0.1);
  color: ${props => props.theme.colors.green5};
  margin-bottom: 20px;
  margin-top: 12px;
  padding: 8px 10px;
  border-radius: 4px;

  ${media.smallAndDown`
    margin-top: 18px;
  `}
`;

const Anchor = styled.a`
  text-decoration: underline !important;
  font-weight: bold;
`;

const SearchMeta = ({ resultTerm, resultCount, loading }) => {
  if (loading || !resultTerm) return null;
  return <Info>{`${resultCount} "${resultTerm}" articles found`}</Info>;
};

const SearchSection = ({
  searchTerm,
  resultTerm,
  resultCount,
  onChange,
  loading,
  ...passProps
}) => {
  return (
    <Section>
      <InputContainer>
        {Boolean(searchTerm) && (
          <ClearButton onClick={() => onChange('')}>
            <XCircle size={24} />
          </ClearButton>
        )}
        <Input
          onChange={event => onChange(event.target.value)}
          value={searchTerm}
          {...passProps}
          placeholder="Search for an article"
        />
      </InputContainer>
      <SearchMeta
        resultTerm={resultTerm}
        resultCount={resultCount}
        loading={loading}
      />
      <SearchQnaSection>
        Searching for products, discussions or topics instead? Click{' '}
        <Link href={`/search?s=${searchTerm}`} passHref>
          <Anchor>here</Anchor>
        </Link>
        !
      </SearchQnaSection>
    </Section>
  );
};

SearchSection.propTypes = {
  searchTerm: PropTypes.string,
  resultTerm: PropTypes.string,
  resultCount: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

SearchSection.defaultProps = {
  searchTerm: '',
  resultTerm: '',
  resultCount: 0,
  loading: false,
};

export default SearchSection;
